import { render, staticRenderFns } from "./AttendanceDetails.vue?vue&type=template&id=38706fa8&scoped=true"
import script from "./AttendanceDetails.vue?vue&type=script&lang=js"
export * from "./AttendanceDetails.vue?vue&type=script&lang=js"
import style0 from "./AttendanceDetails.vue?vue&type=style&index=0&id=38706fa8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38706fa8",
  null
  
)

export default component.exports